import React from 'react'

export default function ColorIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="20" rx="1" fill="#D8B79F" />
        </svg>

    )
}
